<template>
    <div class="form-group">
        <label :for="`${model.status.formId}_${name}`">{{label}}</label>
        <input type="text"
            :id="`${model.status.formId}_${name}`"
            :placeholder="placeholder"
            class="form-control"
            :name="name"
            v-model="model.vals[name]"
            :disabled="model.status.disabled || disabled"
            :required="required"
        />
    </div>
</template>

<script>
export default {
    props:{
        name:String,
        label:String,
        model:Object,
        placeholder:{
            type:String,
            default:"",
        },
        disabled:{
            type:Boolean,
            default:false,
        },
        required:{
            type:Boolean,
            default:false
        },
    }
}
</script>

<style>

</style>
